import * as React from "react";

import {
  Loading,
  useJoinForm,
  useLoginForm,
  useOneTimePasswordUserExperienceFirstStepSendCode,
  useOneTimePasswordUserExperienceSecondStepVerifyCode,
} from "../../Common";

export const AppLoading: React.FunctionComponent = () => {
  const { isLoading: isJoinFormLoading } = useJoinForm();
  const { isLoading: isLoginFormLoading } = useLoginForm();
  const { isLoading: isOneTimePasswordSendCodeLoading } =
    useOneTimePasswordUserExperienceFirstStepSendCode();
  const { isLoading: isOneTimePasswordVerifyCodeLoading } =
    useOneTimePasswordUserExperienceSecondStepVerifyCode();

  const isLoading = React.useMemo(() => {
    return (
      isJoinFormLoading ||
      isLoginFormLoading ||
      isOneTimePasswordSendCodeLoading ||
      isOneTimePasswordVerifyCodeLoading
    );
  }, [
    isJoinFormLoading,
    isLoginFormLoading,
    isOneTimePasswordSendCodeLoading,
    isOneTimePasswordVerifyCodeLoading,
  ]);

  if (!isLoading) {
    return null;
  }

  return <Loading />;
};
